import script from "./AppForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppForm.vue?vue&type=script&setup=true&lang=ts"

import "./AppForm.vue?vue&type=style&index=0&id=4f86be46&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f86be46"]])

export default __exports__